//Containers
import Search from "../containers/Navigation/Search";
import RouteSelector from "../containers/RouteSelector";
import LocalSelector from "../containers/LocalSelector";
import { views } from "./../services/constants";

const { index, public: publicView, root, investigation } = views;

// this is a seperate variable because
// we need this values in the navigation to handle searchToggle behaviour
// if we are on the global search page we dont want the nav search to open
export const SearchRoute = {
  path: ["/search/:type", "/pesquisa/:type"],
  component: Search,
  props: {
    activeView: index,
    sideNav: false,
    isNews: false
  }
};

const GlobalRoutes = {
  routes: [
    SearchRoute,
    {
      path: ["/search", "/pesquisa"],
      component: Search,
      props: {
        activeView: index,
        sideNav: false,
        isNews: false
      }
    },

    /*{
      path: ["/public-prospective-students", "/publico-futuros-estudantes"],
      component: RouteSelector,
      props: {
        activeView: publicView,
        document: "prospectiveStudents",
        sideNav: false
      }
    },
    {
      path: ["/public-students", "/publico-estudantes"],
      component: RouteSelector,
      props: {
        activeView: publicView,
        document: "publicStudents",
        sideNav: false
      }
    },
    {
      path: [
        "/public-internacional-student",
        "/publico-estudantes-internacionais"
      ],
      component: RouteSelector,
      props: {
        activeView: publicView,
        document: "internacionalStudent",
        sideNav: false
      }
    },
    {
      path: ["/public-alumni", "/publico-alumni"],
      component: RouteSelector,
      props: {
        activeView: publicView,
        document: "alumni",
        sideNav: false
      }
    },
    {
      path: ["/public-people", "/publico-pessoas"],
      component: RouteSelector,
      props: {
        activeView: publicView,
        document: "people",
        sideNav: false
      }
    },
    {
      path: ["/public-society", "/publico-sociedade"],
      component: RouteSelector,
      props: {
        activeView: publicView,
        document: "society",
        sideNav: false
      }
    },
    {
      path: ["/usage-terms", "/termos"],
      component: RouteSelector,
      props: {
        document: "usageTerms",
        sideNav: false
      }
    },
    {
      path: ["/gdpr", "/protecao-dados"],
      component: RouteSelector,
      props: {
        activeView: index,
        document: "rgpd",
        sideNav: false
      }
    },
    {
      path: ["/understand-portal", "/compreender-portal"],
      component: RouteSelector,
      props: {
        activeView: index,
        document: "guidePortal",
        sideNav: false
      }
    },*/
    {
      path: ["/agenda", "/agenda"],
      component: LocalSelector,
      props: {
        activeView: index,
        document: "agenda",
        sideNav: false
      }
    } /*
    {
      path: ["/contacts", "/contactos-gerais"],
      component: RouteSelector,
      props: {
        activeView: index,
        document: "contacts",
        sideNav: false
      }
    },
    {
      path: ["/accessibility", "/acessibilidade"],
      component: RouteSelector,
      props: {
        activeView: index,
        document: "accessibility",
        sideNav: false
      }
    },
    {
      path: ["/site-map", "/mapa-site"],
      component: RouteSelector,
      props: {
        activeView: index,
        document: "siteMap",
        sideNav: false
      }
    },
    {
      path: ["/collaborations", "/colaboracoes"],
      component: RouteSelector,
      props: {
        activeView: index,
        document: "collaborations",
        sideNav: false
      }
    },*/,
    {
      path: ["/news/contacts", "/noticias/contactos"],
      component: LocalSelector,
      props: {
        activeView: index,
        document: "journalContacts",
        sideNav: false,
        isNews: true
      }
    },
    {
      path: ["/news/about", "/noticias/sobre"],
      component: LocalSelector,
      props: {
        activeView: index,
        document: "journalAbout",
        sideNav: false,
        isNews: true
      }
    },
    {
      path: ["/news/dossiers", "/noticias/dossies"],
      component: LocalSelector,
      props: {
        activeView: index,
        document: "journalDossiers",
        sideNav: false,
        isNews: true
      }
    },
    {
      path: ["/news/:categoryId/:newsId", "/noticias/:categoryId/:newsId"],
      component: LocalSelector,
      props: {
        activeView: index,
        document: "journalDetails",
        sideNav: false,
        isNews: true
      }
    },
    {
      path: ["/news/:categoryId", "/noticias/:categoryId"],
      component: LocalSelector,
      props: {
        activeView: index,
        document: "journalList",
        sideNav: false,
        isNews: true
      }
    },
    {
      path: ["/news", "/noticias"],
      component: LocalSelector,
      props: {
        activeView: index,
        document: "journal",
        sideNav: false,
        isNews: true
      }
    },
    {
      path: ["/playground", "/playground"],
      component: LocalSelector,
      props: {
        activeView: index,
        document: "playground",
        sideNav: false
      }
    },
    {
      path: ["/demo/mark/:id", "/demo/mark/:id"],
      component: LocalSelector,
      props: {
        activeView: index,
        document: "demoMark",
        sideNav: false
      }
    },
    {
      path: ["/demo/projects", "/demo/projetos"],
      component: LocalSelector,
      props: {
        activeView: investigation,
        document: "projects"
      }
    },
    {
      path: ["/demo/home", "/demo/home"],
      component: LocalSelector,
      props: {
        activeView: index,
        document: "demoHome",
        sideNav: false
      }
    },
    {
      path: ["/demo/people", "/demo/people"],
      component: LocalSelector,
      props: {
        activeView: index,
        document: "demoPeople",
        isSubWeb: true,
        sideNav: false
      }
    },
    {
      path: ["/demo/courses", "/demo/courses"],
      component: LocalSelector,
      props: {
        activeView: index,
        document: "demoCourses",
        isSubWeb: true,
        sideNav: false
      }
    },
    {
      path: ["/demo", "/demo"],
      component: LocalSelector,
      props: {
        activeView: index,
        document: "demoArticle",
        isSubWeb: true,
        sideNav: false
      }
    },
    {
      path: ["/login", "/login"],
      component: LocalSelector,
      props: {
        activeView: index,
        document: "authenticationCallback",
        isSubWeb: false,
        sideNav: false
      }
    },
    {
      path: ["/services", "/servicos"],
      component: LocalSelector,
      props: {
        activeView: index,
        document: "ourServices",
        isSubWeb: false,
        sideNav: false
      }
    }
  ]
};

export default GlobalRoutes;
